import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'sm4rt:lineItemsSyncRanAt';

function readPersisted(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

let lastSyncRanAt: string | null = readPersisted();
const listeners = new Set<() => void>();

export function setLineItemsSyncRanAt(ts: string): void {
  // Monotonic: ignore stale-clock writes (e.g. a slow manual-sync response
  // arriving after a fresh cron broadcast) so the badge can't roll backwards.
  if (lastSyncRanAt) {
    const prev = new Date(lastSyncRanAt).getTime();
    const next = new Date(ts).getTime();
    if (Number.isFinite(prev) && Number.isFinite(next) && next < prev) return;
  }
  lastSyncRanAt = ts;
  try { localStorage.setItem(STORAGE_KEY, ts); } catch { /* quota / privacy mode */ }
  listeners.forEach(l => l());
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => { listeners.delete(l); };
}

function getSnapshot(): string | null {
  return lastSyncRanAt;
}

export function useLineItemsSyncRanAt(): string | null {
  return useSyncExternalStore(subscribe, getSnapshot, () => null);
}
